/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Rename_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to rename space. Please try again." |
*
* @param {Spaces_Rename_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_rename_error = /** @type {((inputs?: Spaces_Rename_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Rename_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space konnte nicht umbenannt werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to rename space. Please try again.")
});